if (!customElements.get('faq-toggle')) {
  customElements.define(
    'faq-toggle',
    class FaqToggle extends HTMLElement {
      connectedCallback() {
        this.showMoreBtn = this.querySelector('.faq-show-more');
        this.showLessBtn = this.querySelector('.faq-show-less');
        this.sectionId = this.dataset.sectionId;
        
        if (this.showMoreBtn && this.showLessBtn) {
          this.showMoreBtn.addEventListener('click', () => this.showMore());
          this.showLessBtn.addEventListener('click', () => this.showLess());
        }
      }

      getHiddenFaqs() {
        return document.querySelectorAll(`#shopify-section-${this.sectionId} .faq-hidden`);
      }

      showMore() {
        const hiddenFaqs = this.getHiddenFaqs();
        hiddenFaqs.forEach((faq) => {
          faq.classList.remove('faq-hidden');
        });
        if (this.showMoreBtn) this.showMoreBtn.classList.add('hidden');
        if (this.showLessBtn) this.showLessBtn.classList.remove('hidden');
      }

      showLess() {
        const allFaqs = document.querySelectorAll(`#shopify-section-${this.sectionId} [data-faq-index]`);
        const maxVisible = parseInt(this.showMoreBtn?.dataset.maxVisible || this.dataset.maxVisible || '0');
        
        allFaqs.forEach((faq) => {
          const index = parseInt(faq.getAttribute('data-faq-index') || '0');
          if (maxVisible > 0 && index > maxVisible) {
            faq.classList.add('faq-hidden');
          }
        });
        if (this.showMoreBtn) this.showMoreBtn.classList.remove('hidden');
        if (this.showLessBtn) this.showLessBtn.classList.add('hidden');
      }
    }
  );
}
